const Promotion = () =>
  import(
    /* webpackChunkName: "financial-discount-promotion" */ '@/pages/financial/discount/promotion/index.vue'
  )
const CreatePromotion = () =>
  import(
    /* webpackChunkName: "financial-discount-promotion" */ '@/pages/financial/discount/promotion/create.vue'
  )
const EditPromotion = () =>
  import(
    /* webpackChunkName: "financial-discount-promotion" */ '@/pages/financial/discount/promotion/edit.vue'
  )

export default {
  path: 'promotion',
  meta: {
    label: 'promotions',
    auth: 'promotion'
  },
  component: {
    name: 'Promotion',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountPromotion',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Promotion
    },
    {
      name: 'FinancialCreateDiscountPromotion',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePromotion
    },
    {
      name: 'FinancialEditDiscountPromotion',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPromotion,
      props: true
    }
  ]
}
